import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import Banner from "../components/Banner";
import PrivacyPolicy from "../components/Policy Pages/PrivacyPolicy";

const Privacypolicy = () => {
  return (
    <>
      <Banner />

      <section className="hidden lg:block">
        <Navbar />
        <Warning />
      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

export default Privacypolicy;
